import React from 'react';
import classNames from 'classnames';
import styles from '../../../../components/PublicWebsiteNav/styles.sass';
import Img from '../../../../components/Img';

const NavbarWithoutMenu = ({ isAmp }) => (
  <nav className={styles.wrapper}>
    <div
      className={classNames(styles.contentBackground, {
        [`${styles.contentBackgroundFixed}`]: isAmp,
      })}
    >
      <div className={styles.contentWrapper}>
        <Img
          className={!isAmp ? styles.logoImage : null}
          isAmp={isAmp}
          src="https://d12xoj7p9moygp.cloudfront.net/images/anchor-logo-header.png"
          withRetina
          alt="Anchor logo"
          height={33}
          width={132}
        />
      </div>
    </div>
  </nav>
);

export { NavbarWithoutMenu as default, NavbarWithoutMenu };
